export function createReverseMap<
  TKey extends string | number,
  TValue extends string | number,
>(map: Record<TKey, TValue>) {
  const reverseMap: Record<TValue, TKey> = {} as Record<TValue, TKey>
  for (const [key, value] of Object.entries<TValue>(map)) {
    reverseMap[value] = key as TKey
  }

  return reverseMap
}
